import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';

export const businessHoursValidator: ValidatorFn = (control: AbstractControl): { [key: string]: any } | null => {
  const { value } = control;
  const { start, end } = value;
  // Exception when closed.
  if (!start.h && !start.m && !end.h && !end.m) {
    return null;
  }
  const invalid = moment(`${start.h}:${start.m}`, 'HH:mm').isSameOrAfter(moment(`${end.h}:${end.m}`, 'HH:mm'));
  return invalid ? { incoherent: true } : null;
};
